import React from 'react';

interface Props {}

const ArrowRightBig = (props: Props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="27" viewBox="0 0 32 27" fill="none">
            <path
                d="M30.1108 10.3275C30.9639 11.23 31.4013 12.4334 31.4013 13.6137C31.4013 14.794 30.9639 15.9974 30.1108 16.8999L20.7267 26.8281L17.6423 23.5651L24.8609 15.928L0.799317 15.928L0.799317 11.2994L24.839 11.2994L17.6423 3.66236L20.7267 0.399149L30.1108 10.3275Z"
                fill="white"
            />
        </svg>
    );
};
export default ArrowRightBig;
